import {
  RealtimeTenantService,
  RealtimeTenantServiceProps,
  Theme,
} from '@queimadiaria/tenant-connection-front';

export type TenantThemeFile = Theme;

// TO DO - to use this function, you need to pass a cache param.

export async function getRuntimeTenantService() {
  const config: RealtimeTenantServiceProps = {
    env: 'production',
    serviceName: 'new-tv',
    apiKey: 'queima@123',
    tenantId: 'queimadiaria',
    //cacheInstance
  };

  return RealtimeTenantService.init(config);
}
